import { Engine } from '../core/engine/Engine.type'

// const defaultPrevFrame = 1
// const defaultFirstFrame = 2

/**
 * @deprecated use bindEngineToComponentV2
 * @param engine 
 */
export default function bindEngineToComponentV1(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  engine: Engine) {
  throw new Error('deprecated')
}
